module.exports = __webpack_public_path__ + "static/media/Hubei Haoze.995bcf16.webp";